import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ESberPaymentStatusConstant, TOPUP_WIDGET_OPEN_QUERY_PARAMETER } from "../../../../checkUrl/constants";
import { sessionStateMap } from "../../../../checkUrl/persistence/map.dev";
import { EPaymentMethod } from "../../../../getContent/constants";
import { sberPaymentRequest } from "./";
import { EStatus } from "../../../../../../constants";
import { getWindow } from "../../../../../../utils/window";
import { getCommonParamsFromState } from "../../../utils";
export var getSendSberpaymPayment = function getSendSberpaymPayment(_ref) {
  var getUserAccountInfo = _ref.getUserAccountInfo,
    createWidget = _ref.createWidget;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState) {
      var _getUserAccountInfo$a, _state$scenario, _state$scenario$captc, _state$scenario$captc2;
      var state, isAuthenticated, accountNumber, ctn, captcha, _getCommonParamsFromS, from, sum, _yield$sberPaymentReq, data, isCaptchaError, bankInvoiceId, _getWindow$location$h, _getWindow, _sessionStateMap$save, widget, backUrl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            isAuthenticated = !!getUserAccountInfo().accountNumber;
            accountNumber = (_getUserAccountInfo$a = getUserAccountInfo().accountNumber) !== null && _getUserAccountInfo$a !== void 0 ? _getUserAccountInfo$a : state.phoneInput.value;
            ctn = state.phoneInput.value;
            if (!(((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SberPay)) {
              _context.next = 6;
              break;
            }
            throw new Error('selected payment is not sberpay');
          case 6:
            captcha = (_state$scenario$captc = (_state$scenario$captc2 = state.scenario.captchaInput) === null || _state$scenario$captc2 === void 0 ? void 0 : _state$scenario$captc2.value) !== null && _state$scenario$captc !== void 0 ? _state$scenario$captc : '';
            _getCommonParamsFromS = getCommonParamsFromState(state, accountNumber, isAuthenticated), from = _getCommonParamsFromS.from, sum = _getCommonParamsFromS.sum;
            _context.next = 10;
            return sberPaymentRequest({
              ctn: ctn,
              fromCtn: from,
              bindingId: null,
              sum: sum,
              captcha: captcha
            });
          case 10:
            _yield$sberPaymentReq = _context.sent;
            data = _yield$sberPaymentReq.data;
            isCaptchaError = _yield$sberPaymentReq.isCaptchaError;
            if (!isCaptchaError) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return", EStatus.CaptchaError);
          case 15:
            if (data) {
              _context.next = 17;
              break;
            }
            throw new Error('no data returned from sber payment request');
          case 17:
            bankInvoiceId = data.sbolBankInvoiceId || data.orderId;
            if (bankInvoiceId) {
              _context.next = 20;
              break;
            }
            throw new Error('no bank invoice id');
          case 20:
            _context.prev = 20;
            widget = createWidget('PRODUCTION');
            backUrl = new URL((_getWindow$location$h = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href) !== null && _getWindow$location$h !== void 0 ? _getWindow$location$h : '');
            backUrl.search = [TOPUP_WIDGET_OPEN_QUERY_PARAMETER, ESberPaymentStatusConstant.StatusParameter].join('&');
            (_sessionStateMap$save = sessionStateMap.saveSum) === null || _sessionStateMap$save === void 0 || _sessionStateMap$save.save();
            _context.next = 27;
            return widget.open({
              bankInvoiceId: bankInvoiceId,
              backUrl: backUrl.toString()
            });
          case 27:
            _context.next = 32;
            break;
          case 29:
            _context.prev = 29;
            _context.t0 = _context["catch"](20);
            return _context.abrupt("return", EStatus.PaymentError);
          case 32:
            return _context.abrupt("return", undefined);
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[20, 29]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};